import {emotionStyled, tokens} from '@packages/utilities/styled';

export const FormLabelView = emotionStyled('label')(
  {
    color: '$textPrimary',
    display: 'block',
    fontSize: '$body',
    lineHeight: '$body',
  },
  {
    componentName: 'FormLabel',
    variants: {
      alignToInput: {
        horizontal: {
          paddingTop: tokens.space[1],
        },
      },
    },
  }
);

export const RequiredIndicatorView = emotionStyled('span')({
  color: '$textPrimary',
  fontSize: '$body',
  marginLeft: '$0.5',
  lineHeight: 1,
});
